import type { PurchaseStatus } from '@/services/purchases';

const STYLES: Record<PurchaseStatus, { label: string; cls: string; icon: string }> = {
  pending: { label: 'Sin pagar', cls: 'bg-amber-100 text-amber-700', icon: 'ri-time-line' },
  partial: { label: 'Abonada', cls: 'bg-secondary-100 text-secondary-700', icon: 'ri-wallet-3-line' },
  paid: { label: 'Pagada', cls: 'bg-emerald-100 text-emerald-700', icon: 'ri-check-line' },
  cancelled: { label: 'Cancelada', cls: 'bg-red-100 text-red-700', icon: 'ri-close-circle-line' },
};

interface PurchaseStatusBadgeProps {
  status: PurchaseStatus;
}

export default function PurchaseStatusBadge({ status }: PurchaseStatusBadgeProps) {
  const s = STYLES[status];
  return (
    <span
      className={`inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${s.cls}`}
    >
      <i className={s.icon}></i>
      {s.label}
    </span>
  );
}